import { useTranslation } from 'react-i18next';
import ForceOptionsReadoutSwitch from './ForceOptionsReadoutSwitch';

// Per-question voice settings section (sibling to QuestionConversationSettings). Holds the
// voice-channel options for this question — today just "always read options aloud", built so
// further voice rows drop in below with the same SettingRow shape.
const QuestionVoiceSettings = () => {
  const { t } = useTranslation('Questionsv2');

  return (
    <div className="flex flex-col gap-3">
      <div className="flex items-center gap-3">
        <h3 className="text-sm font-semibold">{t('voiceSettings.heading')}</h3>
        <div className="h-px flex-1 bg-gray-200" />
      </div>

      <div className="flex flex-col divide-y divide-gray-100">
        <ForceOptionsReadoutSwitch />
      </div>
    </div>
  );
};

export default QuestionVoiceSettings;
